import {TypedEvent} from "../event/TypedEvent";
import {ViewStatus} from "../event/EventStaus";

export abstract class AbstractView<T> {

    readonly _template: T;
    public eventEmitter: TypedEvent<string>;

    protected constructor(template: T) {

        this._template = template;
        this.eventEmitter = new TypedEvent<string>();
    }

    init(): void {

    }

    resize(): void {

    }

    reset(): void {

    }

    update(): void {

    }

    onScroll(top: number): void {

    }

    getChildBySelector(selector: string): T {
        return;
    }

    transitionIn(): void {

        this.resize();
        /* GSAP.TweenMax.killTweensOf(this);
         GSAP.TweenMax.set(this.template, {alpha: 0});
         GSAP.TweenMax.to(this.template, 0.5, {
             alpha: 1,
             ease: GSAP.Circ.easeOut,
             onComplete: () => {
                 this.onTransitionCompleted<null>(ViewStatus.ON_TRANSITION_OUT_COMLETED);
             }
         });*/
    }

    transitionOut<ArgType>(arg?: ArgType): void {

        /*GSAP.TweenMax.killTweensOf(this);
        GSAP.TweenMax.to(this.template, 0.7, {
            alpha: 0,
            ease: GSAP.Circ.easeIn,
            onComplete: () => {
                this.onTransitionCompleted<ArgType>(ViewStatus.ON_TRANSITION_OUT_COMLETED, arg)
            }
        });*/
    }

    onTransitionCompleted<ArgType>(type: string, arg?: ArgType): void {

        if (type === ViewStatus.ON_TRANSITION_IN_COMLETED) {
        }

        if (type === ViewStatus.ON_TRANSITION_OUT_COMLETED) {
            this.reset();
        }
        this.eventEmitter.emit(type, arg);
    }

    get template(): T {
        return this._template;
    }
}